module.exports = __webpack_public_path__ + "static/jadiliana-2f11aef9e33d00ec6ac3c19bcc793a10.png";